/**
 * header 返回按钮
 */

import React from "react"
import "./index.less"

export function HeaderBackBtn() {
  const click = function () {
    let refer_dictionary = ["18.cn", "1234567.com.cn", "18.com.cn", "eastmoney.com"]
    let this_refer = document.referrer
    let isEM
    if (!this_refer) {
      window.location.href = "/"
    } else {
      for (let i = 0; i < refer_dictionary.length; i++) {
        if (this_refer.indexOf(refer_dictionary[i]) > -1) {
          isEM = true
          break
        } else {
          isEM = false
        }
      }

      if (isEM) {
        if (navigator.userAgent.indexOf("MSIE") >= 0 && navigator.userAgent.indexOf("Opera") < 0) {
          // IE
          if (history.length > 0) {
            window.history.go(-1)
          } else {
            window.location.href = "/"
          }
        } else {
          //非IE浏览器
          if (navigator.userAgent.indexOf("Firefox") >= 0 || navigator.userAgent.indexOf("Opera") >= 0 || navigator.userAgent.indexOf("Safari") >= 0 || navigator.userAgent.indexOf("Chrome") >= 0 || navigator.userAgent.indexOf("WebKit") >= 0) {
            if (window.history.length > 1) {
              window.history.go(-1)
            } else {
              window.location.href = "/"
            }
          } else {
            //未知的浏览器
            window.history.go(-1)
          }
        }
      } else {
        window.location.href = "/"
      }
    }
  }

  return (
    <a
      href="#"
      className="headerbackbtn"
      onClick={(e) => {
        e.preventDefault()
        click()
      }}
    ></a>
  )
}

export function StockMoreHeaderBackBtn(props: { market: number; code: string }) {
  const click = function () {
    window.location.href = `/quote/stock/${props.market}.${props.code}.html`
  }

  return (
    <a
      href="#"
      className="headerbackbtn"
      onClick={(e) => {
        e.preventDefault()
        click()
      }}
    ></a>
  )
}
